
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Router, NavigationCancel } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';
import { TimedDialogService } from './timedDialog.service';
import { ConfigService } from './config/config.service';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
  public runningTimer: any;
  public arpSessionTimeoutMessage = "HTTP 401: Unauthorized";
  constructor(
    private config?: ConfigService,
    private router?: Router,
  private logger?: NGXLogger,
    private timedDialogService?: TimedDialogService
  ) {}
  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler): Observable<HttpEvent<any>> {
    const token = sessionStorage.getItem('access_token');
    if (req.url.includes('office-api') || req.url.includes('tpa-api')) {
      if (!this.config.arpUsap) {
        this.timedDialogService.showDialogAfterDelay();
      }
    }
    const changedReq = req.clone({
      setHeaders: {
        Authorization: 'Bearer ' + token,
      },
    });
    return next.handle(changedReq).pipe(tap((event) => {
      // do nothing here on success
    }, (err) => {
      if (err instanceof HttpErrorResponse && err.status === 401) {
        if (err.error) {
          let errorObj = err.error;
          // Parsing is failing due some of cases value is returned as string
          if (typeof errorObj === 'string') {
            errorObj = JSON.parse(errorObj);
          }
          if (errorObj.errors && errorObj.errors[0] && errorObj.errors[0].code === 37355) {
            // Permission denied
            this.logger.error('Unauthorized: '
              + errorObj.errors[0].code + '-' +
              errorObj.errors[0].message);
            return;
          }
        }
        // TODO remove alert add custom dialog
  this.logger.error('Server response: 401. Redirecting to Login page');
        alert('Session Timeout. Please Login');
        sessionStorage.clear();
        // naviagation is not working already other navigation is in progress
        if (this.config.arpUsap) {
          window.parent.postMessage(this.arpSessionTimeoutMessage, "*");
        } else {
          this.router.navigate(['/login']);
        }
        // return throwError(new NavigationCancel(4, '', ''));
      }
    }));
  }
}